import React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"

const SwitcherWrapper = styled.div`
  position: fixed;
  top: 10%;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 9999;

  @media (max-width: 768px) {
    top: auto;
    bottom: 20px;
    right: 15px;
    flex-direction: row;
    gap: 10px;
  }
`

const FlagButton = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid ${({ active }) => (active ? "#1e90ff" : "transparent")};
  background-color: #fff;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.25s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 10px rgba(30, 144, 255, 0.35);
  }

  img {
    width: 80%;
    height: 80%;
    border-radius: 50%;
    object-fit: cover;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-width: 1.5px;

    img {
      width: 78%;
      height: 78%;
    }
  }
`

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const currentLang = i18n.language || "es"

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    localStorage.setItem("lang", lang)

    const url = new URL(window.location.href)
    url.searchParams.set("lang", lang)
    window.history.replaceState({}, "", url.toString())
  }

  return (
    <SwitcherWrapper>
      <FlagButton
        onClick={() => changeLanguage("es")}
        active={currentLang.startsWith("es")}
        title="Español"
      >
        <img
          src="https://flagcdn.com/h120/mx.png"
          alt="Bandera de México"
          loading="lazy"
        />
      </FlagButton>

      <FlagButton
        onClick={() => changeLanguage("en")}
        active={currentLang.startsWith("en")}
        title="English"
      >
        <img
          src="https://flagcdn.com/h120/us.png"
          alt="Flag of the United States"
          loading="lazy"
        />
      </FlagButton>
    </SwitcherWrapper>
  )
}
